import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import JobDetails from '../components/forms/JobDetails';
import PersonalInfo from '../components/forms/PersonalInfo';
import Compliance from '../components/forms/Compliance';
import ExitDetails from '../components/forms/ExitDetails';
import SalaryContract from '../components/forms/SalaryContract';
import Education from '../components/forms/Education';
import Experience from '../components/forms/Experience';
import '../styles/EmployeeMaster.css';
import EmployeeTable from '../components/EmployeeTable';
import Documents from '../components/forms/Documents';
import { getEmployeesForMaster, deleteEmployee } from '../components/api/EmpMasterApi';
import EditEmployeeModal from './EditEmployeeModal';
import { activateEmployee } from '../components/api/EmpMasterApi'; // Add this import

// import {
//      generalInfoMock, 
//      personalInfoMock,
//      jobDetailsMock, 
//      salaryContractMock,
//      complianceMock,  
//      exitDetailsMock,
//      educationExperienceMock,
//      experienceMock,
//      bankInfoMock,
//      documentsMock
// } from '../mockEmployeeMasterData';
import '../styles/pune.css';
import BankInfo from '../components/forms/BankInfo';

const EmployeeMaster = () => {
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const [employees, setEmployees] = useState([]);
     const [totalRecords, setTotalRecords] = useState(0);
     const [filter, setFilter] = useState('');
     const [debouncedFilter, setDebouncedFilter] = useState('');
     // Pagination state
     const [currentPage, setCurrentPage] = useState(1);
     const [itemsPerPage, setItemsPerPage] = useState(10);
     const [allMode, setAllMode] = useState(false);

     // Add/Edit mode state
     const [formMode, setFormMode] = useState('add'); // 'add' or 'edit'
     const [isSaving, setIsSaving] = useState(false);

     // Add confirmation modal state
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const [employeeToDelete, setEmployeeToDelete] = useState(null);
     const [isDeleting, setIsDeleting] = useState(false);
     const [deleteValidationError, setDeleteValidationError] = useState(null);
     const [statusFilter, setStatusFilter] = useState('A');
     // Handler to open delete confirmation modal
     const handleDeleteClick = (employee) => {
          setEmployeeToDelete(employee);
          setDeleteValidationError(null); // <-- clear previous validation errors
          setShowDeleteModal(true);
     };

     // Add confirm delete handler
     // const handleConfirmDelete = async () => {
     //      if (!employeeToDelete || isDeleting) return;

     //      try {
     //           setIsDeleting(true);

     //           // Show loading toast
     //           const loadingToast = toast.loading('Deleting employee...');

     //           // Pass employee_code instead of emp_id
     //           await deleteEmployee(employeeToDelete.employee_code);

     //           // Update success toast
     //           toast.update(loadingToast, {
     //                render: `Employee ${employeeToDelete.employee_name} (${employeeToDelete.employee_code}) deleted successfully!`,
     //                type: 'success',
     //                isLoading: false,
     //                autoClose: 3000
     //           });

     //           // Refresh employee list
     //           let per_page = itemsPerPage === 'all' ? 10000 : itemsPerPage;
     //           const data = await getEmployeesForMaster({ per_page });

     //           if (Array.isArray(data)) {
     //                setEmployees(data);
     //           } else if (data && Array.isArray(data.data)) {
     //                setEmployees(data.data);
     //           }

     //           // Close modal
     //           setShowDeleteModal(false);
     //           setEmployeeToDelete(null);

     //      } catch (error) {
     //           console.error('Error deleting employee:', error);
     //           toast.error(error.message || 'Failed to delete employee');
     //      } finally {
     //           setIsDeleting(false);
     //      }
     // };

     const handleConfirmDelete = async () => {
          if (!employeeToDelete || isDeleting) return;

          console.log('=== DELETE VALIDATION START ===');
          console.log('employeeToDelete:', employeeToDelete);

          // Strict validation: ensure ALL exit details fields are present before allowing delete
          const resignation = (employeeToDelete.resignation || '').toString().trim();
          const resignationDate = (employeeToDelete.resignation_date || '').toString().trim();
          const relievingDate = (employeeToDelete.relieving_date || '').toString().trim();
          const lastWorkingDate = (employeeToDelete.last_working_date || '').toString().trim();
          const lastPayDate = (employeeToDelete.last_pay_date || '').toString().trim();
          const separationStatus = (employeeToDelete.separation_status || '').toString().trim();
          const noticePeriod = (employeeToDelete.notice_period || '').toString().trim();
          const resignationReason = (employeeToDelete.resignation_reason || '').toString().trim();

          console.log('Exit Details Values:');
          console.log('- resignation:', resignation);
          console.log('- resignationDate:', resignationDate);
          console.log('- relievingDate:', relievingDate);
          console.log('- lastWorkingDate:', lastWorkingDate);
          console.log('- lastPayDate:', lastPayDate);
          console.log('- separationStatus:', separationStatus);
          console.log('- noticePeriod:', noticePeriod);
          console.log('- resignationReason:', resignationReason);

          const missing = [];
          if (resignation.toLowerCase() !== 'yes') missing.push('Resignation must be "Yes"');
          if (!resignationDate) missing.push('Resignation date is required');
          if (!relievingDate) missing.push('Relieving date is required');
          if (!lastWorkingDate) missing.push('Last working date is required');
          if (!lastPayDate) missing.push('Last pay date is required');
          if (!separationStatus) missing.push('Separation status is required');
          if (!noticePeriod) missing.push('Notice period is required');
          if (!resignationReason) missing.push('Resignation reason is required');

          console.log('Missing fields:', missing);
          console.log('missing.length:', missing.length);

          if (missing.length > 0) {
               // Show a clear validation message and ask user to add Exit Details
               const errorMsg = `Please add complete Exit Details before deleting employee:\n\n${missing.join('\n')}`;
               console.log('Setting deleteValidationError:', errorMsg);
               setDeleteValidationError(errorMsg);
               console.log('=== VALIDATION FAILED - RETURNING ===');
               return;
          }

          console.log('=== VALIDATION PASSED - PROCEEDING WITH DELETE ===');
          // Clear validation and proceed with delete
          setDeleteValidationError(null);

          try {
               setIsDeleting(true);
               const loadingToast = toast.loading('Deleting employee...');

               await deleteEmployee(employeeToDelete.employee_code);

               toast.update(loadingToast, {
                    render: `Employee ${employeeToDelete.employee_name} (${employeeToDelete.employee_code}) deleted successfully!`,
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000
               });

               let per_page = itemsPerPage === 'all' ? 10000 : itemsPerPage;
               const data = await getEmployeesForMaster({ per_page, status: statusFilter, search: debouncedFilter.trim(), page: currentPage });

               if (Array.isArray(data)) {
                    setEmployees(data);
               } else if (data && Array.isArray(data.data)) {
                    setEmployees(data.data);
               }

               setShowDeleteModal(false);
               setEmployeeToDelete(null);
          } catch (error) {
               console.error('Error deleting employee:', error);
               toast.error(error.message || 'Failed to delete employee');
          } finally {
               setIsDeleting(false);
          }
     };


     const handleAddExitDetails = () => {
          if (!employeeToDelete) return;
          setShowDeleteModal(false);
          setFormMode('edit');
          setEditEmployeeData({
               ...employeeToDelete,
               emp_type: (employeeToDelete.emp_type || '').trim().toUpperCase(),
          });
          setShowEditModal(true);
          setDeleteValidationError(null);
     };

     const handleCancelDelete = () => {
          setShowDeleteModal(false);
          setEmployeeToDelete(null);
          setDeleteValidationError(null); // clear any validation message
     };



     // Lifted form states
     const [generalInfo, setGeneralInfo] = useState({});
     const [personalInfo, setPersonalInfo] = useState({});
     const [jobDetails, setJobDetails] = useState({});
     const [salaryContract, setSalaryContract] = useState({});
     const [compliance, setCompliance] = useState({});
     const [exitDetails, setExitDetails] = useState({});
     const [education, setEducation] = useState({});
     const [bankInfo, setBankInfo] = useState({});
     const [experience, setExperience] = useState({});
     // Documents state - moved to proper location
     const [documents, setDocuments] = useState({ files: [], info: [] });

     const handleCloseModal = () => {
          navigate('/employee-master');
          setFormMode('add');
          resetAllForms();
     };
     // Edit modal state (commented out, now handled in EditEmployeeModal.js)
     const [showEditModal, setShowEditModal] = useState(false);
     const [editEmployeeData, setEditEmployeeData] = useState(null);

     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/dashboard/employee-master/add';
     // Handler to open edit modal (now handled in EditEmployeeModal.js)
     const handleEditClick = (employee) => {
          setEditEmployeeData({
               ...employee,
               emp_type: employee.emp_type ? employee.emp_type.trim().toUpperCase() : '',
          });
          setShowEditModal(true);
          setFormMode('edit');
     };

     // Handler to close edit modal (now handled in EditEmployeeModal.js)
     const handleCloseEditModal = () => {
          setShowEditModal(false);
          setEditEmployeeData(null);
          setFormMode('add');

     };

     const handleActivate = async (employee) => {
          try {
               await activateEmployee(employee.employee_code);
               toast.success(`Employee ${employee.employee_name} activated!`);
               // Refresh list
               let per_page = itemsPerPage === 'all' ? 10000 : itemsPerPage;
               const data = await getEmployeesForMaster({ per_page, status: statusFilter, search: debouncedFilter.trim(), page: currentPage });
               if (Array.isArray(data)) {
                    setEmployees(data);
               } else if (data && Array.isArray(data.data)) {
                    setEmployees(data.data);
               }
          } catch (error) {
               toast.error('Failed to activate employee');
          }
     };

     const apiUrl = `${BASE_URL}/createNewEmployee`;

     const handleAddClick = () => {
          setFormMode('add');
          setGeneralInfo(prev => ({
               ...prev,
               emp_type: prev.emp_type ? prev.emp_type.trim().toUpperCase() : ''
          }));
          navigate('/dashboard/employee-master/add');
     };

     // Download all employees as Excel (all fields, user-friendly headers)
     const handleDownloadExcel = () => {
          if (!employees || employees.length === 0) return;
          // Map of db field to user-friendly header
          const headerMap = {
               emp_id: 'Employee ID',
               employee_code: 'Employee Code',
               employee_name: 'Name',
               designation: 'Designation',
               joining_date: 'Joining Date',
               employment_type: 'Employment Type',
               mobile: 'Mobile',
               emergency_contact: 'Emergency Contact',
               email: 'Email',
               mail: 'Personal Email',
               dob: 'Date of Birth',
               gender: 'Gender',
               father_husband_name: 'Father/Husband Name',
               marital_status: 'Marital Status',
               blood_group: 'Blood Group',
               religion: 'Religion',
               caste: 'Caste',
               department_category: 'Department Category',
               main_department: 'Main Department',
               sub_department: 'Sub Department',
               designation_name: 'Designation Name',
               grade_name: 'Grade',
               position: 'Position',
               reporting_manager_name: 'Reporting Manager',
               reporting_manager_empcode: 'Reporting Manager Code',
               functional_manager_name: 'Functional Manager',
               skip_level_manager_empcode: 'Skip Level Manager Code',
               shift_description: 'Shift',
               total_experience: 'Total Experience',
               bank_account_name: 'Bank Account Name',
               bank_account_number: 'Bank Account Number',
               ifsc_code: 'IFSC Code',
               aadhar_number: 'Aadhar Number',
               pan_number: 'PAN Number',
               tds_status: 'TDS Status',
               ctc: 'CTC',
               latest_agreement_valid_date: 'Agreement Valid Date',
               latest_agreement_end_date: 'Agreement End Date',
               latest_contract_fee_revision_amount: 'Contract Fee Revision',
               resignation: 'Resignation',
               resignation_date: 'Resignation Date',
               relieving_date: 'Relieving Date',
               last_working_date: 'Last Working Date',
               last_pay_date: 'Last Pay Date',
               separation_status: 'Separation Status',
               notice_period: 'Notice Period',
               status: 'Status',
               created_at: 'Created At',
               updated_at: 'Updated At',
               company: 'Company',
               pay_group: 'Pay Group',
               city_name: 'City',
               cluster: 'Cluster',
               location_name: 'Location',
               week_off: 'Week Off',
               resignation_reason: 'Resignation Reason'
          };
          // Get all unique keys from all employee objects
          const allKeys = Array.from(
               employees.reduce((set, emp) => {
                    Object.keys(emp).forEach(k => set.add(k));
                    return set;
               }, new Set())
          );
          // Use user-friendly headers if available, else fallback to key
          const headers = allKeys.map(key => headerMap[key] || key);
          // Map data for export with all fields
          const data = employees.map(emp => {
               const row = {};
               allKeys.forEach((key, idx) => {
                    row[headers[idx]] = emp[key] !== undefined && emp[key] !== null ? emp[key] : '';
               });
               return row;
          });
          // Create worksheet and workbook
          const ws = XLSX.utils.json_to_sheet(data, { header: headers });
          // Set column headers as the first row
          XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Employees');
          // Download
          XLSX.writeFile(wb, 'employees.xlsx');
     };

     useEffect(() => {
          const timer = setTimeout(() => {
               setDebouncedFilter(filter);
          }, 300);

          return () => clearTimeout(timer);
     }, [filter]);

     useEffect(() => {
          setCurrentPage(1);
     }, [debouncedFilter, statusFilter, itemsPerPage]);

     const displayedEmployees = employees;
     // Pagination logic
     const totalPages = Math.ceil(totalRecords / itemsPerPage);

     const handlePageChange = (page) => {
          if (page >= 1 && page <= totalPages) setCurrentPage(page);
     };

     const handleItemsPerPageChange = (e) => {
          const value = e.target.value === 'all' ? 'all' : Number(e.target.value);
          setItemsPerPage(value);
          setCurrentPage(1); // Reset to first page when changing page size
     };

     useEffect(() => {
          fetchEmployees({ per_page: itemsPerPage, status: statusFilter, page: currentPage });
          // eslint-disable-next-line
     }, [itemsPerPage, statusFilter, debouncedFilter, currentPage]);


     // Add refs for form validation
     const generalInfoFormRef = useRef();
     const personalInfoFormRef = useRef();
     const jobDetailsFormRef = useRef();
     const educationFormRef = useRef();
     const bankInfoFormRef = useRef();
     const salaryContractFormRef = useRef();
     const complianceFormRef = useRef();
     const exitDetailsFormRef = useRef();
     const experienceFormRef = useRef();
     const documentsFormRef = useRef();

     // Edit form refs
     const editGeneralInfoFormRef = useRef();
     const editPersonalInfoFormRef = useRef();
     const editJobDetailsFormRef = useRef();
     const editEducationFormRef = useRef();
     const editBankInfoFormRef = useRef();
     const editSalaryContractFormRef = useRef();
     const editComplianceFormRef = useRef();
     const editExitDetailsFormRef = useRef();
     const editExperienceFormRef = useRef();
     const editDocumentsFormRef = useRef();
     const refreshEmployeeList = async () => {
          try {
               let per_page = itemsPerPage === 'all' ? 10000 : itemsPerPage;
               const data = await getEmployeesForMaster({
                    per_page,
                    status: statusFilter,
                    search: debouncedFilter.trim(),
                    page: currentPage
               });

               if (Array.isArray(data)) {
                    setEmployees(data);
                    setTotalRecords(data.length);
               } else if (data && Array.isArray(data.data)) {
                    setEmployees(data.data);
                    setTotalRecords(Number(data.total ?? data.data.length ?? 0));
               }
          } catch (error) {
               console.error('Error refreshing employee list:', error);
               toast.error('Failed to refresh employee list');
          }
     };

     // Centralized fetch to always include status and itemsPerPage
     const fetchEmployees = async ({ per_page = itemsPerPage, status = statusFilter, page = currentPage } = {}) => {
          try {
               const per = per_page === 'all' ? 10000 : per_page;
               const data = await getEmployeesForMaster({
                    per_page: per,
                    status,
                    search: debouncedFilter.trim(),
                    page
               });
               if (Array.isArray(data)) {
                    setEmployees(data);
                    setTotalRecords(data.length);
               } else if (data && Array.isArray(data.data)) {
                    setEmployees(data.data);
                    setTotalRecords(Number(data.total ?? data.data.length ?? 0));
               } else {
                    setEmployees([]);
                    setTotalRecords(0);
               }
          } catch (err) {
               console.error('Error fetching employees:', err);
               toast.error('Failed to fetch employees');
          }
     };

     const handleEmpTypeChange = (empType) => {
          setGeneralInfo(prev => ({
               ...prev,
               emp_type: empType
          }));
          // Here, trigger your shift list loading logic for JobDetails or other forms
          // For example, you might set a state like setAvailableShifts(shiftsForEmpType)
     };

     const handleSplitShiftChange = (splitShift) => {
          setGeneralInfo(prev => ({
               ...prev,
               split_shift: splitShift
          }));
     }



     const handleSave = async () => {
          if (isSaving) return; // Prevent double submission
          const isEditMode = formMode === 'edit';

          // 🔧 ADD DEBUGGING: Log the edit states
          // if (isEditMode) {
          //      console.log('=== EDIT MODE DEBUGGING ===');
          //      console.log('editGeneralInfo:', editGeneralInfo);
          //      console.log('editPersonalInfo:', editPersonalInfo);
          //      console.log('editJobDetails:', editJobDetails);
          //      console.log('editBankInfo:', editBankInfo);
          //      console.log('editEducation:', editEducation);
          //      console.log('editSalaryContract:', editSalaryContract);
          //      console.log('editCompliance:', editCompliance);
          //      console.log('editExitDetails:', editExitDetails);
          //      console.log('editExperience:', editExperience);
          //      console.log('editDocuments:', editDocuments);
          // }

          try {
               setIsSaving(true);

               // Determine which form refs and data to use based on mode
               const isEditMode = formMode === 'edit';

               const validations = isEditMode ? [
                    { ref: editGeneralInfoFormRef, name: 'Basic Info' },
                    { ref: editPersonalInfoFormRef, name: 'Personal Info' },
                    { ref: editJobDetailsFormRef, name: 'Job Info' },
                    { ref: editEducationFormRef, name: 'Education' },
                    { ref: editBankInfoFormRef, name: 'Bank Info' },
                    { ref: editSalaryContractFormRef, name: 'Salary/Contract' },
                    { ref: editComplianceFormRef, name: 'Compliance' },
                    { ref: editExitDetailsFormRef, name: 'Exit Details' },
                    { ref: editExperienceFormRef, name: 'Experience' },
                    { ref: editDocumentsFormRef, name: 'Documents' }
               ] : [
                    { ref: generalInfoFormRef, name: 'Basic Info' },
                    { ref: personalInfoFormRef, name: 'Personal Info' },
                    { ref: jobDetailsFormRef, name: 'Job Info' },
                    { ref: educationFormRef, name: 'Education' },
                    { ref: bankInfoFormRef, name: 'Bank Info' },
                    { ref: salaryContractFormRef, name: 'Salary/Contract' },
                    { ref: complianceFormRef, name: 'Compliance' },
                    { ref: exitDetailsFormRef, name: 'Exit Details' },
                    { ref: experienceFormRef, name: 'Experience' },
                    { ref: documentsFormRef, name: 'Documents' }
               ];

               const invalidForms = [];

               validations.forEach(({ ref, name }) => {
                    if (ref.current?.validateForm && !ref.current.validateForm()) {
                         invalidForms.push(name);
                    }
               });

               if (invalidForms.length > 0) {
                    toast.error(`Please fill all required fields in: ${invalidForms.join(', ')}`);
                    return;
               }

               // Show loading toast
               const loadingToast = toast.loading(isEditMode ? 'Updating employee...' : 'Saving employee...');


               // Build the employee data for add mode
               let employeeData = {};
               if (!isEditMode) {
                    employeeData = {
                         ...generalInfo,
                         emp_type: generalInfo.emp_type ? generalInfo.emp_type.trim().toUpperCase() : '',
                         ...personalInfo,
                         ...jobDetails,
                         ...salaryContract,
                         ...compliance,
                         ...exitDetails,
                         ...education,
                         ...bankInfo,
                         ...experience,
                    };
                    if (experience && experience.experiences) {
                         employeeData.experiences = experience.experiences;
                    }
                    if (education && education.educations) {
                         employeeData.educations = education.educations;
                    }
                    if (documents && documents.info) {
                         employeeData.documents = documents.info;
                    }
               }

               // Build FormData
               const formData = new FormData();
               if (!isEditMode) {
                    formData.append('data', JSON.stringify(employeeData));
               }

               // Add files with indexed notation to match backend expectations
               if (documents && documents.files && documents.files.length > 0) {
                    documents.files.forEach((doc, idx) => {
                         if (doc.file) {
                              // Use indexed notation: files[0], files[1], etc.
                              formData.append(`files[${idx}]`, doc.file);
                         }
                    });

                    // Optionally add document names array for backend to use
                    const documentNames = documents.files
                         .filter(doc => doc.file && doc.document_name)
                         .map(doc => doc.document_name);

                    if (documentNames.length > 0) {
                         documentNames.forEach((name, idx) => {
                              formData.append(`document_names[${idx}]`, name);
                         });
                    }
               }

               // Get JWT token
               const token = sessionStorage.getItem('token') || localStorage.getItem('authToken');
               if (!token) {
                    toast.error('Authentication token not found. Please login again.');
                    return;
               }

               // Choose the correct API endpoint and method
               // const apiUrl = isEditMode
               //      ? `${BASE_URL}/updateEmployee/${editEmployeeData.emp_id}`
               //      : `${BASE_URL}/createNewEmployee`;

               const method = isEditMode ? 'POST' : 'POST';

               // Send everything in one request
               const response = await fetch(apiUrl, {
                    method: method,
                    headers: {
                         'Authorization': `Bearer ${token}`,
                         // Do NOT set Content-Type; browser will set it for FormData
                    },
                    body: formData,
               });

               const result = await response.json();

               if (!response.ok || !result.status) {
                    try {
                         toast.update(loadingToast, {
                              render: result.message || `Failed to ${isEditMode ? 'update' : 'save'} employee`,
                              type: 'error',
                              isLoading: false,
                              autoClose: 5000
                         });
                    } catch (err) {
                         console.error('Error updating toast:', err);
                         // Optionally log or ignore
                    }
                    return;
               }
               try {
                    // Update the loading toast to success
                    toast.update(loadingToast, {
                         render: `Employee ${isEditMode ? 'updated' : 'saved'} successfully!`,
                         type: 'success',
                         isLoading: false,
                         autoClose: 3000
                    });
               } catch (err) {
                    // Optionally log or ignore
                    console.error('Error updating toast:', err);
               }

               // Refresh employee list with current pagination settings
               let per_page = itemsPerPage === 'all' ? 10000 : itemsPerPage;
               getEmployeesForMaster({ per_page, status: statusFilter, search: debouncedFilter.trim(), page: currentPage }).then(data => {
                    if (Array.isArray(data)) {
                         setEmployees(data);
                    } else if (data && Array.isArray(data.data)) {
                         setEmployees(data.data);
                    }
               });

               // Reset forms and close modal
               if (isEditMode) {
                    handleCloseEditModal();
               } else {
                    resetAllForms();
                    handleCloseModal();
               }
               // 🔧 ADD DEBUGGING: Log the final payload
               console.log('=== FINAL PAYLOAD ===');
               // console.log('employeeData:', employeeData);
          } catch (error) {
               console.error(`Error ${formMode === 'edit' ? 'updating' : 'saving'} employee:`, error);
               toast.error('Network error. Please try again.');
          } finally {
               setIsSaving(false);
          }
     };

     // Helper function to reset forms
     const resetAllForms = () => {
          setGeneralInfo({});
          setPersonalInfo({});
          setJobDetails({});
          setSalaryContract({});
          setCompliance({});
          setExitDetails({});
          setEducation({});
          setBankInfo({});
          setExperience({});
          setDocuments({ files: [], info: [] });
     };

     // Mock data handler
     // const handleFillMockData = () => {
     //      setGeneralInfo(generalInfoMock);
     //      setPersonalInfo(personalInfoMock);
     //      setJobDetails(jobDetailsMock);
     //      setSalaryContract(salaryContractMock);
     //      setCompliance(complianceMock);
     //      setExitDetails(exitDetailsMock);
     //      setEducation(educationExperienceMock);
     //      setBankInfo(bankInfoMock);
     //      setExperience({ experiences: experienceMock });

     //      // Update documents mock to match new structure
     //      setDocuments({
     //           files: documentsMock || [],
     //           info: (documentsMock || []).map(doc => ({
     //                document_name: doc.document_name,
     //                file_type: doc.file?.type,
     //                file_size: doc.file?.size,
     //                original_name: doc.file?.name
     //           }))
     //      });
     // };


     const modalTabs = [
          {
               label: 'Basic Info',
               content:
                    <GeneralInfoForm
                         ref={generalInfoFormRef}
                         formData={generalInfo}
                         setFormData={setGeneralInfo}
                         formMode={formMode}
                         employees={employees}
                         onEmpTypeChange={handleEmpTypeChange}
                         onSplitShiftChange={handleSplitShiftChange}
                    />
          },
          { label: 'Personal Info', content: <PersonalInfo ref={personalInfoFormRef} formData={personalInfo} setFormData={setPersonalInfo} /> },
          { label: 'Job Info', content: <JobDetails ref={jobDetailsFormRef} formData={jobDetails} setFormData={setJobDetails} emp_type={generalInfo.emp_type} split_shift={generalInfo.split_shift} /> },
          { label: 'Education', content: <Education ref={educationFormRef} formData={education} setFormData={setEducation} /> },
          { label: 'Bank', content: <BankInfo ref={bankInfoFormRef} formData={bankInfo} setFormData={setBankInfo} /> },
          { label: 'Salary / Contract', content: <SalaryContract ref={salaryContractFormRef} formData={salaryContract} setFormData={setSalaryContract} /> },
          { label: 'Compliance', content: <Compliance ref={complianceFormRef} formData={compliance} setFormData={setCompliance} /> },
          { label: 'Experience', content: <Experience ref={experienceFormRef} formData={experience} setFormData={setExperience} /> },
          { label: 'Documents', content: <Documents ref={documentsFormRef} documents={documents} setDocuments={setDocuments} /> },
     ];

     // Only include Exit Details tab when editing an existing employee
     if (formMode === 'edit') {
          modalTabs.splice(6, 0, { label: 'Exit Details', content: <ExitDetails ref={exitDetailsFormRef} formData={exitDetails} setFormData={setExitDetails} /> });
     }

     return (
          <div className="employee-master-page">
               <ToastContainer position="top-right" />

               <div className="employee-header" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <h2 style={{ marginRight: 'auto' }}>
                         {statusFilter === "A" ? "Active" : "Inactive"} Employee Master</h2>
                    <label style={{ marginBottom: 0, fontWeight: 500 }}>
                         Records per page:
                         <select
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                              style={{ marginLeft: 6, marginRight: 18, padding: '2px 8px', borderRadius: 4 }}
                         >
                              <option value={10}>10</option>
                              <option value={20}>20</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value="all">All</option>
                         </select>
                    </label>
                    <button className="btn btn-outline-success btn-sm" style={{ marginRight: 10 }} onClick={handleDownloadExcel}>
                         Download Excel
                    </button>
                    <input
                         type="text"
                         placeholder="Search "
                         value={filter}
                         onChange={e => setFilter(e.target.value)}
                         className="form-control"
                         style={{ maxWidth: 300, marginRight: 12, padding: 4 }}
                    />
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Employee
                    </button>

                    <select
                         value={statusFilter}
                         onChange={e => {
                              const val = e.target.value;
                              setStatusFilter(val);
                              setCurrentPage(1);
                         }}
                         style={{ marginRight: '1rem', maxWidth: '80px' }}
                         className="form-control form-control-sm"
                    >
                         <option value="A">Active</option>
                         <option value="I">Inactive</option>
                    </select>
               </div>



               <EmployeeTable
                    employees={displayedEmployees}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    onActivate={handleActivate} // <-- Add this line
               />

               {/* Pagination Controls - always show if more than one page */}
               {(!allMode && totalPages > 1) && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20 }}>
                         <div style={{ fontWeight: 500 }}>Total Records: {totalRecords}</div>
                         <nav className="pagination-nav">
                              <ul className="pagination justify-content-center" style={{ marginBottom: 0 }}>
                                   <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>&laquo;</button>
                                   </li>
                                   {/* Windowed Pagination Logic */}
                                   {(() => {
                                        const pages = [];
                                        let start = Math.max(1, currentPage - 4);
                                        let end = Math.min(totalPages, currentPage + 5);

                                        if (currentPage <= 5) {
                                             start = 1;
                                             end = Math.min(10, totalPages);
                                        } else if (currentPage > totalPages - 5) {
                                             start = Math.max(1, totalPages - 9);
                                             end = totalPages;
                                        }

                                        if (start > 1) {
                                             pages.push(
                                                  <li key={1} className={`page-item${currentPage === 1 ? ' active' : ''}`}>
                                                       <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
                                                  </li>
                                             );
                                             if (start > 2) {
                                                  pages.push(
                                                       <li key="start-ellipsis" className="page-item disabled">
                                                            <span className="page-link">...</span>
                                                       </li>
                                                  );
                                             }
                                        }

                                        for (let page = start; page <= end; page++) {
                                             pages.push(
                                                  <li key={page} className={`page-item${currentPage === page ? ' active' : ''}`}>
                                                       <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                                                  </li>
                                             );
                                        }

                                        if (end < totalPages) {
                                             if (end < totalPages - 1) {
                                                  pages.push(
                                                       <li key="end-ellipsis" className="page-item disabled">
                                                            <span className="page-link">...</span>
                                                       </li>
                                                  );
                                             }
                                             pages.push(
                                                  <li key={totalPages} className={`page-item${currentPage === totalPages ? ' active' : ''}`}>
                                                       <button className="page-link" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                                                  </li>
                                             );
                                        }

                                        return pages;
                                   })()}
                                   <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>&raquo;</button>
                                   </li>
                              </ul>
                         </nav>
                    </div>
               )}

               {/* Add Employee Modal */}
               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    animation={true}
                    backdropClassName="custom-modal-backdrop"
                    dialogClassName="animate__animated animate__fadeInRightBig customslide"
               >
                    <Modal.Header closeButton>
                         <b>Add New Employee</b>
                    </Modal.Header>
                    <Modal.Body>
                         <Tabs
                              tabs={modalTabs}
                         />
                         {/* <Tabs
                              tabs={[
                                   {
                                        label: 'Basic Info',
                                        content:
                                             <GeneralInfoForm
                                                  ref={generalInfoFormRef}
                                                  formData={generalInfo}
                                                  setFormData={setGeneralInfo}
                                                  formMode={formMode}
                                                  employees={employees}
                                                  onEmpTypeChange={handleEmpTypeChange}
                                                  onSplitShiftChange={handleSplitShiftChange}
                                             />
                                   },
                                   { label: 'Personal Info', content: <PersonalInfo ref={personalInfoFormRef} formData={personalInfo} setFormData={setPersonalInfo} /> },
                                   // { label: 'Job Info', content: <JobDetails ref={jobDetailsFormRef} formData={jobDetails} setFormData={setJobDetails} /> },
                                   { label: 'Job Info', content: <JobDetails ref={jobDetailsFormRef} formData={jobDetails} setFormData={setJobDetails} emp_type={generalInfo.emp_type} split_shift={generalInfo.split_shift} /> },
                                   { label: 'Education', content: <Education ref={educationFormRef} formData={education} setFormData={setEducation} /> },
                                   { label: 'Bank', content: <BankInfo ref={bankInfoFormRef} formData={bankInfo} setFormData={setBankInfo} /> },
                                   { label: 'Salary / Contract', content: <SalaryContract ref={salaryContractFormRef} formData={salaryContract} setFormData={setSalaryContract} /> },
                                   { label: 'Compliance', content: <Compliance ref={complianceFormRef} formData={compliance} setFormData={setCompliance} /> },
                                   { label: 'Exit Details', content: <ExitDetails ref={exitDetailsFormRef} formData={exitDetails} setFormData={setExitDetails} /> },
                                   { label: 'Experience', content: <Experience ref={experienceFormRef} formData={experience} setFormData={setExperience} /> },
                                   { label: 'Documents', content: <Documents ref={documentsFormRef} documents={documents} setDocuments={setDocuments} /> },
                              ]}
                         /> */}
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                              Close
                         </Button>
                         <Button
                              variant="primary"
                              size="sm"
                              onClick={handleSave}
                              disabled={isSaving}
                              style={{ marginLeft: 8 }}
                         >
                              {isSaving ? 'Saving...' : 'Save'}
                         </Button>
                    </Modal.Footer>
               </Modal>

               {/* Edit Employee Modal */}
               {/* <Modal
                    show={showEditModal}
                    onHide={handleCloseEditModal}
                    animation={true}
                    backdropClassName="custom-modal-backdrop"
                    dialogClassName="animate__animated animate__fadeInRightBig customslide"
               >
                    <Modal.Header closeButton>
                         <b>Edit Employee</b>
                    </Modal.Header>
                    <Modal.Body>
                         <Tabs
                              tabs={[
                                   {
                                        label: 'Basic Info',
                                        content: <GeneralInfoForm
                                             ref={editGeneralInfoFormRef}
                                             formData={editGeneralInfo}
                                             setFormData={setEditGeneralInfo}
                                             formMode={formMode}
                                             employees={employees} />
                                   },
                                   { label: 'Personal Info', content: <PersonalInfo ref={editPersonalInfoFormRef} formData={editPersonalInfo} setFormData={setEditPersonalInfo} /> },
                                   { label: 'Job Info', content: <JobDetails ref={editJobDetailsFormRef} formData={editJobDetails} setFormData={setEditJobDetails} /> },
                                   { label: 'Education', content: <Education ref={editEducationFormRef} formData={editEducation} setFormData={setEditEducation} /> },
                                   { label: 'Bank', content: <BankInfo ref={editBankInfoFormRef} formData={editBankInfo} setFormData={setEditBankInfo} /> },
                                   { label: 'Salary / Contract', content: <SalaryContract ref={editSalaryContractFormRef} formData={editSalaryContract} setFormData={setEditSalaryContract} /> },
                                   { label: 'Compliance', content: <Compliance ref={editComplianceFormRef} formData={editCompliance} setFormData={setEditCompliance} /> },
                                   { label: 'Exit Details', content: <ExitDetails ref={editExitDetailsFormRef} formData={editExitDetails} setFormData={setEditExitDetails} /> },
                                   { label: 'Experience', content: <Experience ref={editExperienceFormRef} formData={editExperience} setFormData={setEditExperience} /> },
                                   { label: 'Documents', content: <Documents ref={editDocumentsFormRef} documents={editDocuments} setDocuments={setEditDocuments} /> },
                              ]}
                         />
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" size="sm" onClick={handleCloseEditModal}>
                              Close
                         </Button>
                         <Button
                              variant="primary"
                              size="sm"
                              onClick={handleSave}
                              disabled={isSaving}
                              style={{ marginLeft: 8 }}
                         >
                              {isSaving ? (formMode === 'edit' ? 'Updating...' : 'Saving...') : (formMode === 'edit' ? 'Update Employee' : 'Save')}
                         </Button>
                    </Modal.Footer>
               </Modal> */}

               <EditEmployeeModal
                    show={showEditModal}
                    onClose={handleCloseEditModal}
                    employee={editEmployeeData}
                    employees={employees}
                    setFormData={setEditEmployeeData}
                    formMode="edit"
                    onSave={refreshEmployeeList} // Add this callback
               />
               {/* Delete Confirmation Modal */}
               <Modal
                    show={showDeleteModal}
                    onHide={handleCancelDelete}
                    animation={true}
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <div className="text-center">

                              {deleteValidationError && (
                                   <div className="alert alert-warning text-left">
                                        <strong>Delete blocked:</strong>
                                        <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{deleteValidationError}</pre>
                                   </div>
                              )}

                              <p className="mb-2">Are you sure you want to delete this employee?</p>
                              {employeeToDelete && (
                                   <div className="bg-light p-3 rounded">
                                        <strong>{employeeToDelete.employee_name}</strong><br />
                                        <small className="text-muted">
                                             Code: {employeeToDelete.employee_code}<br />
                                             Resignation: {employeeToDelete.resignation || 'N/A'}<br />
                                             Resignation Date: {employeeToDelete.resignation_date || '-'}<br />
                                             Relieving Date: {employeeToDelete.relieving_date || '-'}
                                        </small>
                                   </div>
                              )}
                              <p className="text-danger mt-2 mb-0">
                                   <small>This action cannot be undone!</small>
                              </p>
                         </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                         {deleteValidationError ? (
                              <>
                                   <Button variant="secondary" onClick={handleCancelDelete} disabled={isDeleting}>
                                        Close
                                   </Button>
                                   <Button variant="primary" onClick={handleAddExitDetails}>
                                        Add Exit Details
                                   </Button>
                              </>
                         ) : (
                              <>
                                   <Button variant="secondary" onClick={handleCancelDelete} disabled={isDeleting}>
                                        Cancel
                                   </Button>
                                   <Button
                                        variant="danger"
                                        onClick={() => {
                                             console.log('Delete button clicked!');
                                             handleConfirmDelete();
                                        }}
                                        disabled={isDeleting}
                                   >
                                        {isDeleting ? 'Deleting...' : 'Delete'}
                                   </Button>
                              </>
                         )}
                    </Modal.Footer>
               </Modal>
          </div>
     );
};

export default EmployeeMaster;